import {Router, Routes, UrlTree} from '@angular/router';
import {authGuardGuard, loggedOut} from './shared/guards/auth-guard-guard';
import {inject} from '@angular/core';
import {AuthService} from './shared/services/auth';

function suggestionGuard() {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    if (authService.isLoggedIn()) return router.createUrlTree(['/suggestions']);
    return true;
  };
}

export const routes: Routes = [
  {path: '', loadComponent: () => import('./home-page/home-page').then(m => m.HomePage)},
  {path: 'share/:id', loadComponent: () => import('./detail-page/detail-page').then(m => m.DetailPage)},
  {path: 'home', loadComponent: () => import('./home-page/home-page').then(m => m.HomePage)},
  {path: 'login', loadComponent: () => import('./components/login/login').then(m => m.Login), canActivate: [loggedOut]},
  {path: 'pages/child-safety', loadComponent: () => import('../app/pages/child-safety/child-safety').then(m => m.ChildSafety)},
  {path: 'pages/privacy-policy', loadComponent: () => import('../app/pages/privacy-policy/privacy-policy').then(m => m.PrivacyPolicy)},
  {
    path: 'suggestions', loadComponent: () => import('../app/suggestion-page/suggestion-page').then(m => m.SuggestionPage),
    canActivate: [authGuardGuard]
  },
  {
    path: 'suggestions/:type', loadComponent: () => import('../app/suggestion-page/suggestion-page').then(m => m.SuggestionPage),
    canActivate: [authGuardGuard, suggestionGuard(),]
  },
  {path: 'user/detail/:id', loadComponent: () => import('../app/detail-page/detail-page').then(m => m.DetailPage), canActivate: [authGuardGuard]},
  {
    path: 'dashboard', loadComponent: () => import('../app/dashboard/dashboard').then(m => m.Dashboard),
    canActivate: [authGuardGuard],
    children: [
      {
        path: 'messages', loadComponent: () => import('../app/dashboard/pages/chat-screen/chat-screen').then(m => m.ChatScreen),
        children: [{
          path: ':guid',
          loadComponent: () => import('../app/dashboard/pages/chat-screen/chat-messages/chat-messages').then(m => m.ChatMessages),
        }]
      },
      {path: 'saved-users', loadComponent: () => import('../app/dashboard/saved-profiles/saved-profiles').then(m => m.SavedProfiles),},
      {path: 'liked-users', loadComponent: () => import('../app/dashboard/likes-page').then(m => m.LikesPage),},
      {path: 'rejected-users', loadComponent: () => import('../app/dashboard/pages/rejected-users-page').then(m => m.RejectedUsersPage),},
      {path: 'incoming-requests', loadComponent: () => import('../app/dashboard/pages/incoming-requests').then(m => m.IncomingRequestsPage),},
      {path: 'matches', loadComponent: () => import('../app/dashboard/pages/my-matches/my-matches').then(m => m.MyMatches),},
      {path: 'my-liked-users', loadComponent: () => import('../app/dashboard/pages/i-liked').then(m => m.ILikedUsersPage),},
      {path: 'edit-profile', loadComponent: () => import('../app/dashboard/edit-profile/edit-profile').then(m => m.EditProfile),},
    ]
  },
];
